import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getToken, setToken, removeToken } from '@/utils/auth';
import AuthCode from '@/components/AuthCode/';
export default {
  name: 'Login',
  components: {
    AuthCode: AuthCode
  },
  data: function data() {
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!value || value.length < 1) {
        callback(new Error('请输入用户名'));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value || value.length < 6) {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    var validateCode = function validateCode(rule, value, callback) {
      if (!value || value.length < 1) {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value || value.length == 0) {
        callback(new Error('请输入手机号码'));
      } else if (!/^1[3457689]\d{9}$/.test(value)) {
        callback(new Error('手机号码格式不正确'));
      } else {
        callback();
      }
    };
    var validateAuthcode = function validateAuthcode(rule, value, callback) {
      if (!value || value.length < 4) {
        callback(new Error('请输入短信验证码'));
      } else {
        callback();
      }
    };
    return {
      verifyUrl: '',
      verifyImg: 'https://api.szdianlala.com/agentapi/getVerify',
      platformConfig: {},
      loginType: '1',
      loginForm: {},
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }],
        code: [{
          required: true,
          trigger: 'blur',
          validator: validateCode
        }]
      },
      authForm: {},
      authRules: {
        phone_num: [{
          required: true,
          trigger: 'blur',
          validator: validatePhone
        }],
        captche_num: [{
          required: true,
          trigger: 'blur',
          validator: validateAuthcode
        }]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      gid: this.$route.params.gid || '',
      showProjectSelector: false,
      // 控制项目选择器弹窗显示
      selectedProject: null,
      // 记录用户选择的项目
      isLoggedIn: false,
      // 记录用户是否已登录
      gridItems: [{
        id: 1,
        name: '充电桩'
      }, {
        id: 2,
        name: '充电线'
      }, {
        id: 3,
        name: '充电宝'
      }, {
        id: 4,
        name: '套套机'
      }, {
        id: 5,
        name: '汽车充电桩'
      }, {
        id: 6,
        name: '无人机'
      }]
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.getPlatformConfig();
    this.verifyUrl = this.verifyImg;

    // 检查用户是否已登录
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus: function checkLoginStatus() {
      // 检查是否存在有效的登录token
      var token = getToken();
      if (token) {
        // 用户已登录，检查是否已经选择了项目
        var selectedProject = localStorage.getItem('selectedProject');
        if (selectedProject) {
          this.selectedProject = selectedProject;
          // 如果用户已经选择了项目，直接跳转到home页面
          location.href = this.redirect || '/home';
        } else {
          // 如果用户已登录但没有选择项目，显示项目选择器
          this.showProjectSelector = true;
        }
      } else {
        // 用户未登录，只显示登录表单，不显示项目选择器
        this.showProjectSelector = false;
      }
    },
    refreshVerify: function refreshVerify() {
      var _this = this;
      this.verifyUrl = '';
      setTimeout(function () {
        _this.verifyUrl = _this.verifyImg + '?v=' + Math.random();
      }, 300);
    },
    /**
     * 获取平台信息
     */
    getPlatformConfig: function getPlatformConfig() {
      var _this2 = this;
      this.$store.dispatch('user/getPlatformConfig', {
        agent_id: this.gid || this.config.default_agent_id
      }).then(function (res) {
        _this2.platformConfig = res;
      });
    },
    /**
     * 显示密码
     */
    showPwd: function showPwd() {
      var _this3 = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this3.$refs.password.focus();
      });
    },
    /**
     * 密码登录
     */
    handleLogin: function handleLogin() {
      var _this4 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          _this4.$store.dispatch('user/login', _this4.loginForm).then(function (res) {
            if (res.agent_level == 5) {
              _this4.$store.dispatch('user/postSetRecode', [0, 1, 2]);
              _this4.$store.dispatch('user/getInfo').then(function (data) {
                if (data.virtual_divide == 1) {
                  // 登录成功后显示项目选择器
                  _this4.showProjectSelector = true;
                } else {
                  // 登录成功后显示项目选择器
                  _this4.showProjectSelector = true;
                }
                _this4.loading = false;
              });
            } else {
              // this.$store.dispatch('user/postSetRecode', [0,1,2])
              // 登录成功后显示项目选择器
              _this4.showProjectSelector = true;
              _this4.loading = false;
            }
          }).catch(function () {
            _this4.verifyUrl = _this4.verifyImg + '?v=' + Math.random();
            _this4.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 获取验证码
     */
    getAuthCode: function getAuthCode() {
      var _this5 = this;
      this.$refs.authForm.validateField('phone_num', function (valid) {
        if (valid) return false;
        _this5.$refs.authCode.getAuthCode({
          phone_num: _this5.authForm.phone_num,
          platform_agent_id: _this5.gid,
          type: 3
        });
      });
    },
    /**
     * 验证码登录
     */
    authLogin: function authLogin() {
      var _this6 = this;
      this.$refs.authForm.validate(function (valid) {
        if (valid) {
          _this6.loading = true;
          _this6.$store.dispatch('user/codeLogin', _this6.authForm).then(function (res) {
            if (res.status_code == 'NEW_USER') {
              _this6.$router.push({
                path: '/regist',
                query: {
                  'gid': _this6.gid
                }
              });
            } else {
              // 登录成功后显示项目选择器
              _this6.showProjectSelector = true;
            }
          }).catch(function () {
            _this6.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 显示项目选择器
     */
    showProjectSelection: function showProjectSelection() {
      this.showProjectSelector = true;
    },
    /**
     * 处理管理员入口点击
     */
    handleAdminClick: function handleAdminClick() {
      this.$message.success("\u6B63\u5728\u524D\u5F80\u591A\u9879\u76EE\u7BA1\u7406\u7AEF...");
      // 记录用户已选择项目
      this.selectedProject = 'admin';
      // 保存选择到localStorage
      localStorage.setItem('selectedProject', 'admin');
      // 关闭弹窗并跳转到主页
      this.showProjectSelector = false;
      location.href = this.redirect || '/home';
    },
    /**
     * 处理项目点击
     */
    handleItemClick: function handleItemClick(item) {
      this.$message.info("".concat(item.name, "\u6A21\u5757\u5F00\u53D1\u4E2D"));
      // 记录用户已选择项目
      this.selectedProject = item.name;
      // 保存选择到localStorage
      // 关闭弹窗并跳转到对应的项目页面
      // this.showProjectSelector = false;
      // 这里可以替换为实际的路由跳转逻辑
      // 示例：this.$router.push({ name: item.name });
    }
  }
};